export default "__VITE_PUBLIC_ASSET__5ed3d622__"